function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 119.18,
  r: 17.83
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 146.17,
  cy: 66.78,
  r: 17.83,
  transform: "rotate(-30 69.806 94.324)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.83,
  cy: 66.78,
  r: 17.83,
  transform: "matrix(.5 -.87 .87 .5 -58.92 38.58)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M89.59 116.5a58 58 0 0027.51-18.87M26.89 97.58a58 58 0 0027.49 18.87M15.39 48.89A58.05 58.05 0 0018 82.15M63.09 4A57.71 57.71 0 0033 18.41M111 18.4A57.71 57.71 0 0080.91 4M126 82.15a58.05 58.05 0 002.58-33.25"
});

var SvgCommunity = function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 144 141.01",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgCommunity;